<template>
  <div v-if="this.isLoading" class="smaller">
    <sm-spinner :show="true" />
  </div>
  <tr v-else-if="viewPort == 'extraLarge'" class="sm-customers-table__desktop-item">
    <td class="pmb sm-txt-center">
      <span>{{ item.id }}</span>
    </td>
    <td>{{ item.organization_id }}</td>
    <td class="company">
      <span>{{ item.client_level }}</span>
    </td>

    <!-- <td class="plan">
      <span>{{ item.client_location.created_at | moment('MMM D, YYYY') }}</span>
    </td> -->

    <td>
      <a @click="logIn(item)" target="_blank">
        {{ item.subdomain }}
      </a>
    </td>

    <td class="registered">
      <span>{{ item.name }}</span>
    </td>

    <td>
      <span
        >
        {{ clientAddress(item) }}
        </span
      >
    </td>

    <td class="registered">
      <span>{{ item.email }}</span>
    </td>

    <td>{{ item.client_location.phone }}</td>
    <td>{{ item.number_of_active_users }}</td>
    <td>{{ item.number_of_inactive_users }}</td>
    <td>
      {{
        item.payment_gateway_providers.length > 0
        ? item.payment_gateway_providers[0].processor
        : null
      }}
    </td>
    <td>{{ item.is_active ? 'Active' : 'Not Active' }}</td>
    <td>{{whiteLabelingItem(item)}}</td>
    <td>
      <div class="sm-customers-table__desktop-item-actions-item sm-txt-right">
        <a v-if="item.is_active" href="#" class="icon" @click.prevent="set_is_active(item.id, false)">
          <hint-wrap :text="`Deactivate ${item.name}`">
            <template slot="content">
              <include-svg :name="'icon-settings-deactivate'" />
            </template>
          </hint-wrap>
        </a>
        <a v-else href="#" class="icon" @click.prevent="set_is_active(item.id, true)">
          <hint-wrap :text="`Activate ${item.name}`">
            <template slot="content">
              <include-svg :name="'icon-settings-activate'" />
            </template>
          </hint-wrap>
        </a>
      </div>
    </td>
  </tr>

  <div v-else class="sm-mobile-table-item" :class="{
    open: item.itemOpen,
  }">
    <div class="sm-mobile-table-item-row" @click="toggleItem(item)">
      <div class="sm-mobile-table-item-row-elem name">
        <include-svg :name="'icon-arrow-b-bold'" />
        <span>{{ item.id }}</span>
      </div>
      <div class="sm-mobile-table-item-row-elem username">{{ item.name }}</div>
      <div class="sm-mobile-table-item-row-elem pmb sm-txt-center">
        <span>{{ item.client_level }}</span>
      </div>

      <div v-if="viewPort == 'medium' || viewPort == 'large'" class="sm-mobile-table-item-row-elem status sm-txt-right">
        <div class="sm-customers-table__mobile-status" :class="{ active: item.is_active }">
          {{ item.is_active ? 'Active' : 'Inactive' }}
        </div>
      </div>

      <div class="sm-mobile-table-item-row-elem actions" :class="{
        disabled: item.is_privileged,
      }" @click.stop="showPopup">
        <a href="#"></a>
      </div>
    </div>

    <ul class="sm-mobile-table-item-dropdown sm-customers-table__mobile-dropdown" :class="{ flex: viewPort == 'medium' }">
      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Client ID</span>
        <span>{{ item.id }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Org ID</span>
        <span>{{ item.organization_id }}</span>
      </li>

      <!-- <li>
        <span
          class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title"
          >Name</span
        >
        <span>{{ item.name }}</span>
      </li> -->
      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">level</span>
        <span>{{ item.client_level }}</span>
      </li>

      <!-- <li>
        <span
          class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title"
          >created at</span
        >
        <span>{{
          item.client_location.created_at | moment('MMM D, YYYY')
        }}</span>
      </li> -->


      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Subdomain</span>
        <span><a @click="logIn(item)" target="_blank">
            {{ item.subdomain }}
          </a></span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Business Name</span>
        <span>{{ item.client_location.name }}</span>
      </li>
      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Business Address</span>
        <span>{{ item.client_location.street }} -
          {{ item.client_location.city }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Business Email</span>
        <span>{{ item.email }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Business Phone</span>
        <span>{{ item.client_location.phone }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Active customers</span>
        <span>{{ item.number_of_active_users }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Inactive customers</span>
        <span>{{ item.number_of_inactive_users }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Payment Gateway</span>
        <span>{{
          item.payment_gateway_providers.length > 0
          ? item.payment_gateway_providers[0].processor
          : null
        }}</span>
      </li>

      <li>
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Status</span>
        <span>{{ item.is_active ? 'Active' : 'Not Active' }}</span>
      </li>
      <li>
        <span
          class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title"
          >Status</span
        >
        <span>{{ item.is_active ? 'Active' : 'Not Active' }}</span>
      </li>
      <li>
        <span
          class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title"
          >White Labeling</span
        >
        <span>{{ whiteLabelingItem(item) }}</span>
      </li>
    </ul>
    <div class="sm-mobile-table-item-popup" v-if="item.popupOpen" v-click-outside="hidePopup">
      <ul>
        <li>
          <a v-if="item.is_active" href="#" class="icon" @click.prevent="set_is_active(item.id, false)">Deactivate {{
            item.name }}</a>
          <a v-else href="#" class="icon" @click.prevent="set_is_active(item.id, true)">Activate {{ item.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HintWrap from '@/components/HintWrap';
import Hint from '@/components/Hint';
import { CheckHigherRole } from '@/utils/roles';
import vClickOutside from 'v-click-outside';
import Spinner from '@/components/Spinner';

export default {
  name: 'customers-item',
  components: {
    'hint-wrap': HintWrap,
    'hint-block': Hint,
    'sm-spinner': Spinner,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    viewPort: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showTerm: false,
      showRecipients: false,
      recipientsRequested: false,
      hintTimer: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      user: 'auth/user',
      userAccount: 'account/userAccount',
      provider: 'provider',
      access: 'auth/access',
      countryList: 'countryList',
    }),
    showForm1583Warning() {
      return (
        !this.item.is_privileged &&
        this.item.hasOwnProperty('is_form_1583_signed') &&
        !this.item.is_form_1583_signed &&
        this.provider.country_id == 1
      );
    },
    showNoDocumentsWarning() {
      return (
        this.provider.country_id != 1 &&
        !this.item.is_privileged &&
        this.item.hasOwnProperty('account_approval_status') &&
        this.item.account_approval_status != 'approved'
      );
    },
    showExpiredPhotoIDWarning() {
      return (
        !this.item.is_privileged &&
        this.item.photo_id_expires_on &&
        new Date(this.item.photo_id_expires_on).getTime() < new Date().getTime()
      );
    },
    warning() {
      if (this.showForm1583Warning)
        return 'This user has not signed USPS Form 1583 yet';

      if (this.showNoDocumentsWarning)
        return this.item.required_documents_uploaded
          ? 'Documents waiting approval'
          : 'Account is not approved';

      if (this.showExpiredPhotoIDWarning)
        return "This user's Photo ID is expired.";
      return '';
    },
  },
  methods: {
    ...mapActions({
      alterCustomerStatus: 'operators/alterCustomerStatus',
    }),
    async set_is_active(id, is_active) {
      this.isLoading = true;
      this.alterCustomerStatus({ client_id: id, is_active: is_active })
        .then(() => {
          setTimeout(() => {
            this.$emit('action');
            this.isLoading = false;
          }, 1000);
        })
        .catch(e => {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        });
    },
    checkHigherRole: CheckHigherRole,
    toggleItem(item) {
      item.itemOpen = !item.itemOpen;
    },
    loginAsCustomer() {
      this.$emit('action', {
        name: 'login',
        id: this.item.id,
      });
    },
    activateCustomer() {
      this.$emit('action', {
        name: 'activate',
        id: this.item.id,
      });
    },
    deactivateCustomer() {
      this.$emit('action', {
        name: 'deactivate',
        id: this.item.id,
      });
    },
    deleteCustomer() {
      this.$emit('action', {
        name: 'delete',
        id: this.item.id,
      });
    },
    clientAddress(client) {
      let street = client.client_location.street ? client.client_location.street.replace(/ ,/g, ',') : '';
      let city = client.client_location.city ? `${client.client_location.city}, ` : '';
      let state = client.client_location.state ? `${client.client_location.state.short_name} ` : '';
      let zip = client.client_location.zip_code || '';
      let country = client.client_location.country.name ? client.client_location.country.name : '';

      return `${street}, ${city}, ${state}${zip}, ${country}`
    },
    whiteLabelingItem(item) {
      let value;

      const {vanity_domain_basic , vanity_domain_custom} = item

      if (!vanity_domain_basic && !vanity_domain_custom) {
          value = "Basic";
      } else if (vanity_domain_basic) {
          value = "Plus";
      } else if (vanity_domain_custom) {
          value = "Premium";
      }

      return value
    },
    quickMail(e) {
      e.stopPropagation();

      this.$emit('action', {
        name: 'quick-mail',
        pmb: this.item.pmb,
      });
    },
    showPopup() {
      this.item.popupOpen = true;
    },
    hidePopup() {
      this.item.popupOpen = false;
    },
    openAccount(id, e, documents) {
      if (id == this.userAccount.id) {
        this.$router.push('account');
      } else {
        this.$router.push(`customer/${id}${documents ? '?from=list' : ''}`);
      }

      if (e) e.preventDefault();
    },
    showRecipientsList() {
      this.hintTimer = setTimeout(() => (this.showRecipients = true), 10);

      if (!this.recipientsRequested) {
        this.recipientsRequested = true;
        this.$emit('action', {
          name: 'recipients',
          customer: this.item,
        });
      }
    },
    hideRecipientsList() {
      this.showRecipients = false;
      clearTimeout(this.hintTimer);
    },
    runBilling() {
      this.$emit('action', {
        name: 'billing',
        customer: this.item,
      });
    },
    logIn(location) {
      const wlp = window.location.port;
      const port = wlp === '8080' || wlp === '8081' ? ':' + wlp : '';
      if (location.client_domain) {
        window.open(
          `http${!port ? 's' : ''}://${
            location.client_domain
          }${port}/customers/login?refresh_token=${
            this.access.refresh_token
          }&access_token=${this.access.token}`
        );
      } else {
        window.open(
          `http${!port ? 's' : ''}://${
            location.subdomain
          }.spheremail.co${port}/customers/login?refresh_token=${
            this.access.refresh_token
          }&access_token=${this.access.token}`
        );
      }
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style scoped>
.sm-mobile-table-item-dropdown > li > span:nth-child(1) {
  min-width: 180px;
}
</style>
